<template>
  <VueSlickCarousel class="tools-slider" :arrows="true" :autoplay="true">
    <Tool v-for="route in firstLevelRouts" :key="route.name" :route="route" :tag="$t('products.tools.first-level')"/>
    <Tool v-for="route in addOnRouts" :key="route.name" :route="route" :tag="$t('products.tools.add-on')"/>
    <Tool v-for="route in routes('commingSoon')" :key="route.name" :route="route" :tag="$t('products.tools.coming-soon')"/>
    <Tool v-for="route in allInOneRouts" :key="route.name" :route="route" :tag="$t('products.tools.all-in-one')"/>
    <template #prevArrow>
      <div class="custom-arrow">
        <img src="@/assets/arrow-left.svg">
      </div>
    </template>
    <template #nextArrow>
      <div class="custom-arrow">
        <img src="@/assets/arrow-right.svg">
      </div>
    </template>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import Tool from './ToolSlide.vue'

function routes (productRoutes, groupName, currentRouteName) {
  return productRoutes.filter(route => route.name !== currentRouteName && route.groups && route.groups[groupName]).sort((a, b) => a.groups[groupName] - b.groups[groupName])
}

export default {
  name: 'HomeToolsSlider',
  data () {
    return {
      routes: function (groupName) {
        return this.productRoutes.filter(route => route.name !== this.$route.name && route.groups && route.groups[groupName]).sort((a, b) => a.groups[groupName] - b.groups[groupName])
      }
    }
  },
  computed: {
    productRoutes () { return this.$router.options.routes.find(route => route.name === 'Product').children },
    currentRouteGroup () { return Object.keys(this.productRoutes.find(route => route.name === this.$route.name).groups)[0] },
    firstLevelRouts () { return routes(this.productRoutes, 'firstLevel', this.$route.name) },
    addOnRouts () { return routes(this.productRoutes, 'addOn', this.$route.name) },
    allInOneRouts () { return routes(this.productRoutes, 'allInOne', this.$route.name) }
  },
  components: { VueSlickCarousel, Tool }
}
</script>

<style lang="sass" scoped>
.tools-slider
  padding: 0 40px

.custom-arrow
  color: $dark
  font-size: 14px
  height: 29px
  top: 50%
  &:before
    content: none

  &.slick-next
    right: 15px
  &.slick-prev
    left: 15px
</style>



// WEBPACK FOOTER //
// src/components/ui/HomeToolsSlider.vue